'use client';
import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';

import { StatusCard } from '@/flat-pages/status/ui/status-card';
import {
  SliderWrapper,
  SliderContainer,
  NavigationContainer,
  NavigationButton,
} from './styles';

type StatusSliderT = {
  cardsCount: number;
};

export const StatusSlider = ({ cardsCount }: StatusSliderT) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const hasNavigation = cardsCount > 4;

  return (
    <SliderWrapper>
      {hasNavigation && (
        <NavigationContainer>
          <NavigationButton $dir="prev" ref={prevRef} />
          <NavigationButton $dir="next" ref={nextRef} />
        </NavigationContainer>
      )}
      <SliderContainer>
        <Swiper
          modules={[FreeMode, Navigation]}
          freeMode={{ enabled: true, momentum: true }}
          grabCursor
          slidesPerView="auto"
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
          }}
          breakpoints={{
            0: {
              slidesPerView: 'auto',
              spaceBetween: 18,
              slidesOffsetBefore: 18,
              slidesOffsetAfter: 18,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 24,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 24,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
            },
          }}
        >
          {Array.from({ length: cardsCount }, (_, level) => (
            <SwiperSlide key={level}>
              <StatusCard cardLevel={level} />
            </SwiperSlide>
          ))}
        </Swiper>
      </SliderContainer>
    </SliderWrapper>
  );
};
